/**
 * Javascript specific to the Flyout Filter menus
 *
 * This is a bit more of a manual process than usual because we must append the modal to #page-wrapper instead of just body
 */

(function (window, document, $) {
	'use strict';

	// Adding this line from MichaelTheHuman's answer on this GitHub issue (https://github.com/sweetalert2/sweetalert2/issues/374)
	// regarding inputs no longer working when a modal is open. The reason isn't due to z-index, but rather the focus event.
	$.fn.modal.Constructor.prototype._enforceFocus = function () { };

	// Function to manually open/close the flyout. Since we are appending the modal to the #page-wrapper instead of the body we have to take a couple extra steps
	function open_flyout(){
		$( '#flyout-modal-container' ).modal(
			{
				'show': true,
				'backdrop': false
			}
		);
		$( '#page-wrapper' ).addClass( 'flyout-modal-open' );

		//appending modal background inside #page-wrapper so it doesn't cover the navigation
		$( '.modal-backdrop' ).appendTo( '#page-wrapper' );

		//remove the padding right and modal-open class from the body tag which bootstrap adds when a modal is shown
		$( 'body' ).removeClass( 'modal-open' )
		$( 'body' ).css( 'padding-right', '' );
	}

	// Open the flyout on page load
	if (window.innerWidth > 884){
		open_flyout();
	}

	// Show/Hide the flyout on click
	$( 'body' ).on(
		'click',
		'#flyout-modal-button',
		function (e) {
			e.preventDefault();
			open_flyout();
		}
	);

	$( 'body' ).on(
		'click',
		'button.close',
		function () {
			$( '#page-wrapper' ).removeClass( 'flyout-modal-open' );
			$( '#flyout-modal-container' ).css( 'display', 'none' );
			$( '#flyout-modal-container' ).modal(
				{
					'show': false,
					'backdrop': false
				}
			);
		}
	);

	// Make sure the page wrapper can fit the height of the full flyout
	var flyout_height = $( '#flyout-modal-container' ).outerHeight() + 50; // Flyout height plus 50px to give the bottom of the page some breathing room
	$( '.flyout-wrapper' ).css( 'min-height', flyout_height );

})( window, document, jQuery );
